import TypedChipInput from './TypedChipInput';

export default TypedChipInput;
